import { fetch } from '@financial-tool/fetch';
import { VatInfo } from '../types/user';

export default function getVatInfoAPI(vatNumber: string) {
  return fetch.get<VatInfo>(`/vat/info?vatNumber=${vatNumber}`);
}
